import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0A192F] text-white mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-md bg-[#F97316] grid place-items-center font-heading font-extrabold text-[#0A192F]">
              GJ
            </div>
            <div className="font-heading font-extrabold text-xl tracking-tight">
              Gaddi Junction
            </div>
          </div>
          <p className="mt-4 text-white/70 max-w-md text-sm leading-relaxed">
            Affordable & Trusted Cars For All. West Bengal's modern used car
            marketplace — connecting buyers and dealers across Kolkata, Howrah,
            Durgapur, Asansol and beyond.
          </p>
          <div className="mt-6 space-y-2 text-sm text-white/70">
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-[#F97316]" /> Kolkata, West Bengal
            </div>
            <div className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-[#F97316]" /> +91 89108 84194
            </div>
            <div className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-[#F97316]" /> hello@gaddijunction.in
            </div>
          </div>

          <a
            href="/qr/dealer-signup-qr.png"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-qr-link"
            className="mt-6 inline-flex items-center gap-4 bg-white/5 hover:bg-white/10 transition-colors rounded-xl p-3 border border-white/10 max-w-xs"
          >
            <img
              src="/qr/dealer-signup-qr.png"
              alt="Scan to become a Gaddi Junction dealer"
              className="w-20 h-20 rounded bg-white p-1"
              loading="lazy"
            />
            <div className="leading-tight">
              <div className="text-[10px] uppercase tracking-[0.18em] text-[#F97316] font-bold">
                Scan to join
              </div>
              <div className="text-sm font-semibold mt-1">Become a Dealer</div>
              <div className="text-[11px] text-white/60 mt-0.5">Free for 30 days</div>
            </div>
          </a>
        </div>

        <div>
          <div className="font-heading text-sm uppercase tracking-[0.18em] text-[#F97316] mb-4">
            Marketplace
          </div>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/cars" className="hover:text-[#F97316]">Browse Cars</Link></li>
            <li><Link to="/sell" className="hover:text-[#F97316]">Sell Your Car</Link></li>
            <li><Link to="/dealer-signup" className="hover:text-[#F97316]">Become a Dealer</Link></li>
            <li><Link to="/favourites" className="hover:text-[#F97316]">My Favourites</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-heading text-sm uppercase tracking-[0.18em] text-[#F97316] mb-4">
            Company
          </div>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/terms" className="hover:text-[#F97316]" data-testid="footer-terms-link">Terms &amp; Conditions</Link></li>
            <li><Link to="/privacy" className="hover:text-[#F97316]" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/refund-policy" className="hover:text-[#F97316]" data-testid="footer-refund-link">Refund &amp; Cancellation</Link></li>
            <li><Link to="/disclaimer" className="hover:text-[#F97316]" data-testid="footer-disclaimer-link">Disclaimer</Link></li>
          </ul>
          <div className="flex items-center gap-3 mt-6">
            <a href="#" className="w-9 h-9 grid place-items-center rounded-full bg-white/5 hover:bg-[#F97316] hover:text-[#0A192F] transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="#" className="w-9 h-9 grid place-items-center rounded-full bg-white/5 hover:bg-[#F97316] hover:text-[#0A192F] transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="#" className="w-9 h-9 grid place-items-center rounded-full bg-white/5 hover:bg-[#F97316] hover:text-[#0A192F] transition-colors">
              <Youtube className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 text-xs text-white/50 flex flex-wrap items-center justify-between gap-2">
          <div>© {new Date().getFullYear()} Gaddi Junction. All rights reserved.</div>
          <div>Made with care in Kolkata.</div>
        </div>
      </div>
    </footer>
  );
}
